import { useMemo } from "react";
import { useSelector } from "react-redux";

import { appManageTypes } from "../../../../consts";

export const useIsLocalisationEditing = ({ originalRow, isNameCell, getEditingLocalization }) => {
  const manageType = useSelector((store) => store.apps.manageType);

  const isEdit = useMemo(() => manageType === appManageTypes.EDIT, [manageType]);

  const isLocalizationEditing = useMemo(() => {
    if (!isEdit) {
      return true;
    }

    const editingLocalization = getEditingLocalization();

    if (isEdit && editingLocalization?.isEdit && isNameCell) {
      return false;
    }

    if (originalRow?.isNew && editingLocalization?.isNew) {
      return true;
    }

    return editingLocalization?.isEdit && originalRow?.name === editingLocalization?.name;
  }, [getEditingLocalization, isEdit]);

  return { isEdit, isLocalizationEditing };
};
